export const STOCK_TYPE_QUERY = `
  id
  code
  name
  description
  image
  enabled
`;
